var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-select-v1",class:{ error: _vm.hasError }},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('v-select',{class:[
      _vm.customClass,
      !_vm.disabled ? 'select-chooser' : 'select-chooser-disabled',
    ],attrs:{"placeholder":_vm.placeholder,"label":_vm.selector,"value":_vm.contructedValue,"options":_vm.options,"clearable":false,"disabled":_vm.disabled},on:{"input":_vm.onSelectChange}}),(_vm.hasError)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }